import { appslistTypes } from './appslist.types';

export const makeIsFetchingTrue = () => ({
  type: appslistTypes.MAKE_IS_FETCHING_TRUE,
});

// GET
export const fetchAppslistData = () => ({
  type: appslistTypes.FETCH_APPS_LIST_DATA,
});

export const fetchAppslistDataSuccess = (data) => ({
  type: appslistTypes.FETCH_APPS_LIST_DATA_SUCCESS,
  payload: data,
});

export const fetchAppslistDataFailure = (error) => ({
  type: appslistTypes.FETCH_APPS_LIST_DATA_FAILURE,
  payload: error,
});

// PUT
export const saveAppslistData = ({ appID, enabled }) => ({
  type: appslistTypes.SAVE_APPS_LIST_DATA,
  payload: { appID, enabled },
});

export const saveAppslistDataSuccess = ({ appID, enabled }) => ({
  type: appslistTypes.SAVE_APPS_LIST_DATA_SUCCESS,
  payload: { appID, enabled },
});

export const saveAppslistDataFailure = (error) => ({
  type: appslistTypes.SAVE_APPS_LIST_DATA_FAILURE,
  payload: error,
});

// POST
export const postAppslistData = (data) => ({
  type: appslistTypes.POST_APPS_LIST_DATA,
  payload: data,
});

export const postAppslistDataSuccess = (data) => ({
  type: appslistTypes.POST_APPS_LIST_DATA_SUCCESS,
  payload: data,
});

export const postAppslistDataFailure = (error) => ({
  type: appslistTypes.POST_APPS_LIST_DATA_FAILURE,
  payload: error,
});

// DELETE
export const deleteAppslistData = ({ appID }) => ({
  type: appslistTypes.DELETE_APPS_LIST_DATA,
  payload: { appID },
});

export const deleteAppslistDataSuccess = ({ appID }) => ({
  type: appslistTypes.DELETE_APPS_LIST_DATA_SUCCESS,
  payload: { appID },
});

export const deleteAppslistDataFailure = (error) => ({
  type: appslistTypes.DELETE_APPS_LIST_DATA_FAILURE,
  payload: error,
});
